const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    style: {
      enableBackground: "new 0 0 480 480"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 0 480)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#013E3F"
    },
    d: "M240,8C111.87,8,8,111.87,8,240s103.87,232,232,232s232-103.87,232-232S368.13,8,240,8z M240,312  L104.232,176.232L240,312l135.768-135.768L240,312z",
    "data-original": "#E6E7E8",
    className: "",
    "data-old_color": "#E6E7E8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M240,480C107.452,480,0,372.548,0,240S107.452,0,240,0s240,107.452,240,240   C479.85,372.486,372.486,479.85,240,480z M240,16C116.288,16,16,116.288,16,240s100.288,224,224,224s224-100.288,224-224   C463.859,116.347,363.653,16.141,240,16z",
    "data-original": "#414042",
    className: "active-path",
    "data-old_color": "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M240,320c-2.122,0-4.156-0.844-5.656-2.344L98.576,181.888c-3.069-3.178-2.981-8.243,0.197-11.312   c3.1-2.994,8.015-2.994,11.115,0L240,300.688l130.112-130.112c3.069-3.178,8.134-3.266,11.312-0.196   c3.178,3.069,3.266,8.134,0.196,11.312c-0.064,0.067-0.13,0.132-0.196,0.196L245.656,317.656C244.156,319.156,242.122,320,240,320z   ",
    "data-original": "#414042",
    className: "active-path",
    "data-old_color": "#414042"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandedIcon);
export default __webpack_public_path__ + "static/media/ExpandedIcon.ad622c92f00635e55dc6ee1343b7cfd0.svg";
export { ForwardRef as ReactComponent };